/**
 * PreviewBenefits — Benefits grid with check icons
 */
import { RenderIcon } from './RenderIcon';

interface BenefitItem {
  title: string;
  text: string;
}

interface PreviewBenefitsProps {
  data: {
    title?: string;
    subtitle?: string;
    items?: BenefitItem[];
  };
  settings: {
    [key: string]: any;
  };
}

export function PreviewBenefits({ data, settings }: PreviewBenefitsProps) {
  const items = data.items || [];
  const gridClass =
    items.length === 3
      ? "preview-benefits__grid preview-benefits__grid--three"
      : "preview-benefits__grid";

  return (
    <section className="preview-benefits">
      <div className="preview-container">
        <div className="preview-section-header">
          <h2>{data.title}</h2>
          {data.subtitle && <p>{data.subtitle}</p>}
        </div>

        <div className={gridClass}>
          {items.map((item, i) => (
            <div key={i} className="preview-benefit">
              <div className="preview-benefit__icon">
                <RenderIcon name="check" />
              </div>
              <div>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
